export default "__VITE_ASSET__D$CA3Ysh__"